/**
 * Shop-Verknüpfung aus der Shopify-App: Der Verknüpfungscode überlebt den Umweg über die Anmeldung (E-Mail-Link,
 * ggf. Zwei-Faktor). Nach erfolgreicher Anmeldung geht es zurück zu /shop-verbinden statt zur Übersicht.
 */
const KEY = "lc.shopClaim";
const TTL_MS = 2 * 3_600_000;

export function rememberShopClaim(claim: string) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ claim, at: Date.now() }));
  } catch {
    /* privater Modus: Nutzer öffnet die App in Shopify erneut */
  }
}

export function forgetShopClaim() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* egal */
  }
}

/** Ziel nach der Anmeldung: offene Shop-Verknüpfung oder Übersicht */
export function afterLoginPath(): string {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? "null") as { claim?: string; at?: number } | null;
    if (v?.claim && v.at && Date.now() - v.at < TTL_MS) return `/shop-verbinden?claim=${encodeURIComponent(v.claim)}&mode=existing`;
  } catch {
    /* egal */
  }
  return "/";
}
